/** @jsx jsx */
import { HTMLAttributes } from 'react';
import { Box } from '@balance-web/box';
import { jsx } from '@balance-web/core';
export const Body = (props: HTMLAttributes<HTMLDivElement>) => {
  return <Box flex="1" css={{ overflowY: 'auto' }} {...props} />;
};
